import { AppLayout } from '../authenticated/layout/AccountLayout'
import { GuestLayout } from '../guest/layout/GuestLayout'

import { useAuth } from '../../contexts/AuthContext'

/**
 * The checkout page is reachable by customers, managers and guests (and is where the payment provider sends people
 * back), so it renders inside whichever shell matches the visitor.
 */
const CheckoutLayout = () => {
  const { authInfo } = useAuth()
  return authInfo ? <AppLayout /> : <GuestLayout />
}

export default CheckoutLayout
